import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Breadcrumbs from 'react-router-dynamic-breadcrumbs';
import { Redirect } from 'react-router-dom';

import {
  APIHandler,
  Collection,
  DataHandler,
  VideoCollection,
  ImageCollection,
} from 'C4';
import { storageKeys } from 'settings';

export default class CollectionView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collection: [],
      escaped: false,
    };

    this.onEsc = this.onEsc.bind(this);
  }

  componentWillMount() {
    const { url } = this.props.match;
    document.addEventListener('keydown', this.onEsc);
    DataHandler.matchAppId().then((id) => {
      const appId = id;

      if (url.split('/').slice(-1).pop() === 'images') {
        DataHandler.checkKey(storageKeys.images, APIHandler.getImages(appId))
          .then(res => this.setState({ collection: res.items }));
      } else {
        APIHandler.getNamedCollection(url.split('/').slice(-1).pop().replace(/-/g, ' '), appId)
          .then(res => this.setState({ collection: res.items }));
      }
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onEsc);
  }

  onEsc(e) {
    if (e.key === 'Escape') {
      this.setState({ escaped: true });
    }
  }

  render() {
    const { escaped, collection } = this.state;

    const { url, params } = this.props.match;
    const { videoId } = params;

    const redirPath = (
      videoId !== undefined
        ? url.substring(0, url.lastIndexOf('/')).lastIndexOf('/')
        : url.lastIndexOf('/')
    );

    return (
      <div className="collection__Container">
        <div className="collection__Background--overlay" />

        {url.split('/').slice(-1).pop() === 'images' &&
          Object.values(collection).map(chapter => (
            <ImageCollection
              key={chapter[0].chapter.chapterNumber}
              chapterCollection={chapter}
            />
          ))}
    

        {url.split('/').slice(-1).pop() === 'image-library' &&
          Object.values(collection).map((col, i) => (
            <div className="brochures" key={i}>
              <Collection
                key={col[0].pageID}
                content={col}
                header="Image Library"
              />
            </div>
        ))}

        {url.split('/').slice(-1).pop() !== 'images' &&
          url.split('/').slice(-1).pop() !== 'image-library' &&
        Object.keys(collection).map((key, i) => (
          <div className={`brochures ${url.split('/').slice(-1).pop()}`} key={i}>
            <Collection
              key={collection[key][0].pageID}
              content={collection[key]}
              header={key}
            />
          </div>
          ))}

        {escaped && <Redirect to={url.substring(0, redirPath)} />}
      </div>
    );
  }
}

CollectionView.propTypes = {
  match: PropTypes.shape().isRequired,
};
